import { useNavigateTo } from 'hooks/useNavigateTo'

interface UseOpenModalParams {
  videoInfo: any
}

export default function useOpenModal({ videoInfo }: UseOpenModalParams) {
  const { navigateToEnableVip, navigateToWallet } = useNavigateTo()
  const openEnableVipModal = () => {
    navigateToEnableVip({ fromVideo: true })
  }

  const openDepositModal = () => {
    navigateToWallet({})
  }

  return {
    openEnableVipModal,
    openDepositModal,
  }
}
